<template>
  <section id="faq" class="py-24 bg-white relative">
    <div class="max-w-3xl mx-auto px-6">
      <div v-reveal class="text-center mb-12">
        <div
          class="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#1c4848]/5 border border-[#1c4848]/10 mb-6"
        >
          <iconify-icon icon="solar:question-circle-linear" class="text-[#1c4848]"></iconify-icon>
          <span class="text-xs font-semibold text-[#1c4848] tracking-wide uppercase">
            {{ content.badge }}
          </span>
        </div>
        <h2 class="text-4xl lg:text-5xl font-serif text-[#1c4848] font-semibold tracking-tight">
          {{ content.title }}
        </h2>
      </div>

      <div class="flex flex-col gap-3">
        <details
          v-for="(item, i) in content.items"
          :key="item.q"
          :open="i === 0"
          class="faq-item group bg-[#fafbfc] rounded-3xl border border-[#1c4848]/5 open:bg-white open:shadow-lg transition-all duration-300"
        >
          <summary class="flex items-center justify-between gap-4 cursor-pointer list-none px-6 py-5">
            <h3 class="text-base lg:text-lg font-semibold text-[#1c4848]">{{ item.q }}</h3>
            <iconify-icon
              icon="solar:alt-arrow-down-linear"
              class="text-xl text-[#1c4848]/50 shrink-0 transition-transform duration-300 group-open:rotate-180"
            ></iconify-icon>
          </summary>
          <p class="px-6 pb-6 -mt-1 text-[15px] text-[#1c4848]/70 font-medium leading-relaxed">
            {{ item.a }}
          </p>
        </details>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { siteContent } from '@/seo/siteContent.js';

const { locale } = useI18n();
const content = computed(() => (siteContent[locale.value] ?? siteContent.en).faq);
</script>

<style scoped>
.faq-item summary::-webkit-details-marker {
  display: none;
}
</style>
